import React from 'react'
import { render, screen } from '@testing-library/react'
import FeaturedCard from '../FeaturedCard'
import { FeaturedProps } from '../types.d'

const baseProps: FeaturedProps = {
  heading: 'Heading',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  backgroundColor: 'bg-white',
  badgeColor: 'bg-lavender-0',
  badgeText: 'top',
  borderColor: 'dark',
  elevation: 'floating',
  padding: {
    paddingTop: '24',
    paddingRight: 'null',
    paddingBottom: 'null',
    paddingLeft: '24',
    mobileTop: '16',
    mobileRight: '24',
    mobileBottom: 'null',
    mobileLeft: '16'
  },
  listItems: [
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' }
  ],
  textAlignment: 'center',
  button: {
    label: 'CTA Label',
    link: '#CTA-Link',
    size: 'large',
    variation: 'primary'
  }
}

describe('Featured Card Tests', () => {
  it('Should Render Featured Card with BG White, Raised Shawdow, Dark Border, Lavender Badege, and List containing 3 items', () => {
    render(<FeaturedCard {...baseProps} />)

    // Get FeaturedCard container element by class name
    const featuredcard = screen.getByTestId('featuredcard')
    expect(featuredcard).toBeTruthy()
    expect(featuredcard).toHaveClass(
      'bg-white',
      'border-card-dark',
      'shadow-floating',
      'text-center',
      'md:pt-6',
      'md:pb-6',
      'md:pl-6',
      'md:pr-6',
      'pt-4',
      'pb-6',
      'pl-4',
      'pr-6'
    )

    // Get H3 element
    const heading = screen.getByRole('heading', { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By TestId description
    const description = screen.getByTestId('description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    )

    // Get Badge element By TestId badge
    const badge = screen.getByTestId('badge')
    expect(badge).toBeTruthy()
    expect(badge).toHaveClass('bg-lavender-0')

    // Get List element By TestId list
    const items = screen.getAllByRole('listitem')
    expect(items.length).toBe(3)

    // Get Button element By Role button
    const cta = screen.getByRole('link')
    expect(cta).toBeTruthy()
    expect(cta).toHaveAttribute('href', '#CTA-Link')
    expect(cta.textContent).toContain('CTA Label')
  })
})
